'use strict';

angular.module('dokiv').filter('encodeUri', [
  '$window',
  function ($window) {
    return $window.encodeURIComponent;
  }
]);


//////////////////
// WEBPACK FOOTER
// ./scripts/app/encodeUrl.js
// module id = 260
// module chunks = 0